import { render, staticRenderFns } from "./campus-list.vue?vue&type=template&id=d82077c6&scoped=true&"
import script from "./campus-list.vue?vue&type=script&lang=js&"
export * from "./campus-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d82077c6",
  null
  
)

export default component.exports